import gql from 'not-graphql-tag';

export const validateAccountExists = gql`
  query validateAccountExists($payload: ValidateAccountExistsRequest) {
    validateAccountExists(payload: $payload) {
      result
    }
  }
`;
